module.exports = __webpack_public_path__ + "@/assets/img/pt-pt.23adb9fe.svg";